<template>
  <section>
    <div class="reminder message-configurator">
      <div class="buttons">
        <h2>First Reminder</h2>
        <b-button
          v-if="reminder1Edit == false && canEditRecord"
          type="is-text"
          class="actionBtn"
          @click="editMessage(1)"
          >Edit</b-button
        >

        <b-button
          v-if="reminder1Edit == true"
          type="is-text"
          class="actionBtn"
          @click="
            saveMessage(
              'reminder_1',
              reminder1,
              reminder1Closing,
              communication_language,
              reminder1Footer,
              ''
            )
          "
          >Save</b-button
        >
        <b-button
          v-if="reminder1Edit == true"
          type="is-text"
          @click="cancelMessage(1)"
          >Cancel</b-button
        >
        <b-field>
          <b-select
            required
            v-if="reminder1Edit == true"
            placeholder="Please select"
            size="is-small"
            name="communication_language"
            expanded
            v-model="communication_language"
            v-on:input="setAccountManager"
          >
            <option
              v-for="(option, index) in customerLanguages"
              :value="option.id"
              :key="index"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="card">
        <div v-if="reminder1Edit == false">
          <div class="tags">
            ><span> {{ customer }} </span><br />
          </div>
          <div class="messageContent">
            <p>{{ reminder1 }}</p>
          </div>
          <div>
            <table>
              <tr>
                <th>Customer Name</th>
                <th>Country</th>
                <th>Stream</th>
                <th>Scheme</th>
                <th>Report Type</th>
                <th>Reporting Frequency</th>
                <th>Period</th>
                <th>Client Data Delivery Deadline</th>
                <th>Scheme Deadline</th>
              </tr>
              <tr>
                <td>Fairphone</td>
                <td>Sweden</td>
                <td>Packaging</td>
                <td>FTI</td>
                <td>Standard</td>
                <td>Yearly</td>
                <td>2020-Q4</td>
                <td>31-12-2020</td>
                <td>31-12-2021</td>
              </tr>
              <tr>
                <td>Buy It Direct</td>
                <td>Ireland</td>
                <td>WEEE</td>
                <td>Blackbox</td>
                <td>Standard</td>
                <td>Monthly</td>
                <td>2021-Q1</td>
                <td>31-01-2021</td>
                <td>31-03-2021</td>
              </tr>
              <tr>
                <td>OnePlus</td>
                <td>Finland</td>
                <td>WEEE</td>
                <td>ERP Finland</td>
                <td>Monthly reporting</td>
                <td>Monthly</td>
                <td>2021-Q1</td>
                <td>31-01-2021</td>
                <td>31-02-2021</td>
              </tr>
            </table>
          </div>
          <div>
            <br />
          </div>

          <div class="messageContent">
            <span class="customerMsgBreaker customerMsgHeading"></span><br />
            <div>
              <span class="customerMsg">
                Hi, here is the individual message from the customer´s
                profile</span
              >
            </div>
            <span class="customerMsgBreaker customerMsgHeading"></span><br />
          </div>
          <div class="messageContent">
            <p>{{ reminder1Closing }}</p>
          </div>
          <div class="messageContent">
            <br />
            <p v-html="reminder1Footer"></p>
          </div>
        </div>
        <h3 class="msgLabel" v-if="reminder1Edit == true">Opening Message</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Starting Message"
            v-model="reminder1"
            :readonly="reminder1Edit == false"
            v-if="reminder1Edit == true"
          >
          </b-input>
        </b-field>

        <h3 class="msgLabel" v-if="reminder1Edit == true">Closing Message</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Closing Message"
            v-model="reminder1Closing"
            :readonly="reminder1Edit == false"
            v-if="reminder1Edit == true"
          >
          </b-input>
        </b-field>
        <h3 class="msgLabel" v-if="reminder1Edit == true">Footer</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Footer"
            v-model="reminder1Footer"
            :readonly="reminder1Edit == false"
            v-if="reminder1Edit == true"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <div class="reminder message-configurator">
      <div class="buttons">
        <h2>Second Reminder</h2>
        <b-button
          v-if="reminder2Edit == false && canEditRecord"
          type="is-text"
          class="actionBtn"
          @click="editMessage(2)"
          >Edit</b-button
        >

        <b-button
          v-if="reminder2Edit == true"
          type="is-text"
          class="actionBtn"
          @click="
            saveMessage(
              'reminder_2',
              reminder2,
              reminder2Closing,
              communication_language_r2,
              reminder2Footer,
              reminder2DueReportMsg
            )
          "
          >Save</b-button
        >
        <b-button
          v-if="reminder2Edit == true"
          type="is-text"
          @click="cancelMessage(2)"
          >Cancel</b-button
        >
        <b-field>
          <b-select
            required
            v-if="reminder2Edit == true"
            placeholder="Please select"
            size="is-small"
            name="communication_language_r2"
            expanded
            v-model="communication_language_r2"
            v-on:input="setAccountManager_r2"
          >
            <option
              v-for="(option, index) in customerLanguages"
              :value="option.id"
              :key="index"
            >
              {{ option.name }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="card">
        <div v-if="reminder2Edit == false">
          <div class="tags">
            ><span> {{ customer }} </span><br />
          </div>
          <div class="messageContent">
            <p>{{ reminder2 }}</p>
          </div>
          <div>
            <table class="center tableWidth">
              <tr>
                <th>Customer Name</th>
                <th>Country</th>
                <th>Stream</th>
                <th>Scheme</th>
                <th>Report Type</th>
                <th>Reporting Frequency</th>
                <th>Period</th>
                <th>Client Data Delivery Deadline</th>
                <th>Scheme Deadline</th>
              </tr>

              <tr>
                <td>Withings</td>
                <td>Bulgaria</td>
                <td>Battery</td>
                <td>Nord Elrecycling</td>
                <td>Report for non-Bulgarian companies</td>
                <td>Monthly</td>
                <td>2021-M1</td>
                <td>31-02-2020</td>
                <td>31-12-2021</td>
              </tr>
              <tr>
                <td>Ctrack</td>
                <td>Ireland</td>
                <td>WEEE</td>
                <td>ERP Ireland</td>
                <td>Standard</td>
                <td>Quarterly</td>
                <td>2021-M2</td>
                <td>31-11-2020</td>
                <td>31-01-2021</td>
              </tr>
            </table>
          </div>

          <span class="messageContent">{{ reminder2DueReportMsg }} </span>
          <div>
            <table class="center tableWidth">
              <tr>
                <th>Customer Name</th>
                <th>Country</th>
                <th>Stream</th>
                <th>Scheme</th>
                <th>Report Type</th>
                <th>Reporting Frequency</th>
                <th>Period</th>
                <th>Client Data Delivery Deadline</th>
                <th>Scheme Deadline</th>
              </tr>
              <tr>
                <td>Fairphone</td>
                <td>The Netherlands</td>
                <td>WEEE</td>
                <td>WEEE NL</td>
                <td>Standard</td>
                <td>Bi-annually</td>
                <td>2021-CY</td>
                <td>31-04-2020</td>
                <td>01-04-2021</td>
              </tr>
              <tr>
                <td>Withings</td>
                <td>Bulgaria</td>
                <td>Battery</td>
                <td>Nord Elrecycling</td>
                <td>Report for non-Bulgarian companies</td>
                <td>Monthly</td>
                <td>2021-M1</td>
                <td>31-01-2021</td>
                <td>12-02-2021</td>
              </tr>
            </table>
          </div>

          <div class="messageContent">
            <p>{{ reminder2Closing }}</p>
          </div>
          <div class="messageContent">
            <br />
            <p v-html="reminder2Footer"></p>
            <br />
          </div>
        </div>
        <h3 class="msgLabel" v-if="reminder2Edit == true">Opening Message</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Starting Message"
            v-model="reminder2"
            :readonly="reminder2Edit == false"
            v-if="reminder2Edit == true"
          >
          </b-input>
        </b-field>
        <h3 class="msgLabel" v-if="reminder2Edit == true">
          Due Reports Message
        </h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Due Reports Message"
            v-model="reminder2DueReportMsg"
            :readonly="reminder2Edit == false"
            v-if="reminder2Edit == true"
          >
          </b-input>
        </b-field>
        <h3 class="msgLabel" v-if="reminder2Edit == true">Closing Message</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Closing Message"
            v-model="reminder2Closing"
            :readonly="reminder2Edit == false"
            v-if="reminder2Edit == true"
          >
          </b-input>
        </b-field>
        <h3 class="msgLabel" v-if="reminder2Edit == true">Footer</h3>
        <b-field class="msg">
          <b-input
            type="textarea"
            placeholder="Footer"
            v-model="reminder2Footer"
            :readonly="reminder2Edit == false"
            v-if="reminder2Edit == true"
          >
          </b-input>
        </b-field>
      </div>
    </div>
  </section>
</template>

<script>
import ReminderDataService from "../../services/ReminderDataService";
import { mapGetters } from "vuex";
import { Permission } from "../../services/Permissions";
import CustomerProfileDataService from "../../services/CustomerProfileDataService";
import UtilityMixin from "@/mixins/UtilityMixin";
export default {
  name: "messageConfiguratorComponent",
  mixins: [UtilityMixin],
  data() {
    return {
      canEditRecord: false,
      reminderDataSertvice: new ReminderDataService(),
      isComponentModalActive: true,
      reminder1:
        "We would like to remind you about the declarations of your products placed on the following markets and streams. We would be grateful if you could provide us the datasets [data_delivery_deadline] (data delivery deadline of customer) working days before scheme deadline.",
      reminder1Closing:
        "If you have any questions please send a message your manager: Katharina Effe* k.effe@erp-recycling.org and to Data Management Team lssc@landbellgroup.com",
      reminder1Footer: "Kind Regards<br> EPR Admin",
      reminder2:
        "We would like to remind you once again about the declarations of your products. We would be grateful if you could provide us the datasets immediatly to avoid deadline.",
      reminder2Closing:
        "If you have any questions please send a message your manager: Katharina Effe* k.effe@erp-recycling.org and to Data Management Team lssc@landbellgroup.com",
      reminder2Footer: "Kind Regards<br> EPR Admin",
      reminder2DueReportMsg:
        "Please also be informed about other due reports which needs to be submitted during current reporting period:",
      salutation: "Hi",
      customer: "",
      streams: "Streams",
      markets: "Merkets",
      messageConfigs: [],
      reminder1Edit: false,
      reminder2Edit: false,
      communication_language: null,
      customerLanguages: [],
      customerDataService: new CustomerProfileDataService()
    };
  },
  computed: {
    ...mapGetters(["userHasPermission"])
  },
  mounted() {
    this.checkExternalPermission();
    this.getMessages();
    this.fetchLanguages();
  },
  methods: {
    canEdit() {
      if (this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL)) {
        this.canEditRecord = true;
      }

      return this.canEditRecord;
    },

    setAccountManager(languageID) {
      const msgConfig = this.messageConfigs.filter(function(obj) {
        return obj.language === languageID && obj.type == "reminder_1";
      });
      this.reminder1 = msgConfig[0].message;
      this.originalReminder1 = msgConfig[0].message;
      this.reminder1Closing = msgConfig[0].closing_message;
      this.reminder1Footer = msgConfig[0].footer;
      this.originalReminder1Footer = msgConfig[0].footer;
      this.orignalReminder1Closing = msgConfig[0].closing_message;
      this.communication_language = msgConfig[0].language;
    },
    setAccountManager_r2(languageID) {
      const msgConfig = this.messageConfigs.filter(function(obj) {
        return obj.language === languageID && obj.type == "reminder_2";
      });
      this.reminder2 = msgConfig[0].message;
      this.originalReminder2 = msgConfig[0].message;
      this.reminder2Closing = msgConfig[0].closing_message;
      this.reminder2Footer = msgConfig[0].footer;
      this.reminder2DueReportMsg = msgConfig[0].due_report_msg;
      this.orignalReminder2Footer = msgConfig[0].footer;
      this.orignalReminder2DueReportMsg = msgConfig[0].due_report_msg;
      this.orignalReminder2Closing = msgConfig[0].closing_message;
      this.communication_language_r2 = msgConfig[0].language;
    },
    getMessages() {
      this.canEdit();
      this.reminderDataSertvice.getAll().subscribe(
        response => {
          response.forEach(reminderConfigs => {
            this.messageConfigs.push(reminderConfigs);
            if (reminderConfigs.type == "reminder_1") {
              this.reminder1 = reminderConfigs.message;
              this.originalReminder1 = reminderConfigs.message;
              this.reminder1Closing = reminderConfigs.closing_message;
              this.reminder1Footer = reminderConfigs.footer;
              this.originalReminder1Footer = reminderConfigs.footer;
              this.orignalReminder1Closing = reminderConfigs.closing_message;
              this.communication_language = reminderConfigs.language;
            } else if (reminderConfigs.type == "reminder_2") {
              this.reminder2 = reminderConfigs.message;
              this.originalReminder2 = reminderConfigs.message;
              this.reminder2Closing = reminderConfigs.closing_message;
              this.reminder2Footer = reminderConfigs.footer;
              this.reminder2DueReportMsg = reminderConfigs.due_report_msg;
              this.orignalReminder2Closing = reminderConfigs.closing_message;
              this.orignalReminder2DueReportMsg =
                reminderConfigs.due_report_msg;
              this.orignalReminder2Footer = reminderConfigs.footer;
              this.communication_language_r2 = reminderConfigs.language;
            }
          });
        },
        e => {
          console.log(e);
        }
      );
    },
    editMessage(type) {
      if (type == 1) {
        this.reminder1Edit = true;
      } else {
        this.reminder2Edit = true;
      }
    },
    fetchLanguages() {
      this.customerDataService.getLanguages().subscribe(
        response => {
          this.customerLanguages = response;
        },
        e => {
          console.log(e);
        }
      );
    },

    saveMessage(
      reminderType,
      message,
      closingMsg,
      communication_language,
      footer,
      due_report_msg
    ) {
      this.reminder1Edit = this.reminder2Edit = false;
      const payload = {
        message: message,
        footer: footer,
        closing_message: closingMsg,
        type: reminderType,
        language: communication_language,
        due_report_msg: due_report_msg
      };

      this.reminderDataSertvice.post(payload).subscribe(() => {
        console.log();
      }, this.handleApiError);
    },
    cancelMessage(type) {
      this.reminder1Edit = this.reminder2Edit = false;
      if (type == 1) {
        this.reminder1 = this.originalReminder1;
        this.reminder1Closing = this.orignalReminder1Closing;
        this.reminder1Footer - this.originalReminder1Footer;
      } else {
        this.reminder2 = this.originalReminder2;
        this.reminder2Closing = this.orignalReminder2Closing;
        this.reminder2DueReportMsg = this.orignalReminder2DueReportMsg;
        this.reminder2Footer = this.orignalReminder2Footer;
      }
      location.reload();
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
    },
    routeToCountrySupportOverview() {
      this.$router.push({ name: "reportingTracker.countryOverview" });
    }
  }
};
</script>
